import { useAPI } from '@/services';
import { useGetFundCodeFromQuery } from '@/modules/invest/hooks/useGetFundCodeFromQuery';
import { useFindFundByFundCode } from '@/modules/invest/subModules/fund/hooks/useFindFund';

export const useGetFundHistoryRatio = () => {
  const fundCode = useGetFundCodeFromQuery();

  // * in this hook, fund is always a valid data. if the service ran into problem the user wont call this hook
  const { fund } = useFindFundByFundCode(fundCode);

  const { fundType } = fund!;

  const fundHistoryRatioResponse = useAPI(['fund', 'getFundHistoryRatio'], {
    input: {
      fundCode,
    },
    reactQueryOptions: {
      enabled: fundType === 'FUND',
    },
  });

  const etfHistoryRatioResponse = useAPI(['trade', 'getEtfHistoryRatio'], {
    input: {
      Isin: fundCode,
    },
    reactQueryOptions: {
      enabled: fundType === 'ETF',
    },
  });

  return fundType === 'FUND'
    ? fundHistoryRatioResponse
    : etfHistoryRatioResponse;
};
